import { type FC } from 'react'
import Image from 'next/image'

import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { Button } from 'components/Button'

interface DialogUnconfirmedDirectReportProps
  extends Omit<DialogProps, 'children'> {
  onClick: () => void
}

const DialogUnconfirmedDirectReport: FC<DialogUnconfirmedDirectReportProps> = ({
  onClick = () => {},
  ...props
}) => {
  return (
    <Dialog autoFocus={false} size="md" {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg" data-module="pengelolaan-kinerja">
        <div className="p-6 space-y-3">
          <Text variant="display-sm">
            Kabari Kepala Sekolah untuk konfirmasi data atasan
          </Text>

          <Text variant="body-lg" color="subdued">
            Predikat Kinerja Organisasi dapat dikirim setelah Kepala Sekolah
            konfirmasi data atasan melalui halaman:
          </Text>

          <div>
            <Image
              src="/images/pengelolaan-kinerja/img-confirm-direct-report.png"
              width={720}
              height={265}
              alt="Konfirmasi"
            />
          </div>

          <div className="flex gap-5 !mt-4">
            <Button size="lg" variant="ghost" onClick={onClick}>
              Tutup
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogUnconfirmedDirectReport
